import React from 'react';
import { useTranslation } from 'react-i18next';

import { LabeledSelect } from '../Input/LabeledSelect';

const DomainsSelect = ({ allowClear = true,
  disabled = false, ...props }) => {
  const [ t ] = useTranslation();

  return (
    <LabeledSelect
      placeholder={ t('fields.choose') }
      allowClear={ allowClear }
      options={ [
        { text: t('fields.domains.human'), value: '1' },
        { text: t('fields.domains.vet'), value: '2' }
      ] }
      disabled={ disabled }
      { ...props }
    />
  );
};
export default DomainsSelect;
